module.exports = "<div id=\"gsiLoginButton\" > </div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/login/google-login/google-login.component.html
// module id = ./client/app/login/google-login/google-login.component.html
// module chunks = main